















import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { isMobile } from 'mobile-device-detect';

import CommentList from './components/CommentList.vue';
import EditCommentModal from './components/EditCommentModal.vue';
import { Actions } from './store/actions';
import { Getters } from './store/getters';
import { CommentView, CommentAdd, CommentEdit } from './store/models';

import { commentsModuleName } from './store/index';
const commentsModule = namespace(commentsModuleName);

@Component({
  components: {
    CommentList,
    EditCommentModal,
  },
})
export default class Comments extends Vue {

  @Prop() private contentObjectId!: number;
  @Prop() private requireLogin!: boolean;

  private modalId: string = 'mini-chat-edit-comment-modal';
  private isBusy: boolean = true;
  private commentToAddEdit: CommentAdd | CommentEdit = { userName: '', text: '', fromMobile: isMobile };
  private $auth: any = (this as any).$auth;

  @commentsModule.Getter(Getters.COMMENTS) private comments!: string;
  @commentsModule.Action(Actions.FETCH_COMMENTS) private fetchComments!: (contentObjectId: number | null) => void;

  public async mounted() {
    await this.fetchComments(this.contentObjectId);
    this.isBusy = false;
  }

  private handleAddComment() {
    this.commentToAddEdit = { userId: this.getUserId,
                              userName: this.getUserName,
                              fromMobile: isMobile,
                              text: '',
                              contentObjectId: this.contentObjectId};
    this.showModal();
  }

  private handleEditComment(comment: CommentView): void {
    this.commentToAddEdit = { id: comment.id, text: comment.text, changedBy: this.getUserId };
    this.showModal();
  }

  private showModal(): void {
    this.$nextTick(() => ((this as any).$bvModal.show(this.modalId)));
  }

  get getUserId() {
    return this.$auth.isAuthenticated ? this.$auth.userProfile.userId : undefined;
  }

  get getUserName() {
    return this.$auth.isAuthenticated ? this.$auth.userProfile.userName : '';
  }

  get isLoading() {
    return this.isBusy || (this as any).$auth.loading;
  }

  private login() {
    (this as any).$auth.loginWithRedirect();
  }

  private async saveSucceeded() {
    this.isBusy = true;
    await this.fetchComments(this.contentObjectId);
    this.isBusy = false;
  }
}
